import { AxiosError, AxiosResponse } from 'axios'
import { camelize } from 'casing'
import {
  startLoading,
  stopLoading,
  LoadingTypes,
  errorLogger,
} from '@labrav/common'
import { getBuyerRevenuesAPI } from '../../api/marketplace/index'
import type { AppDispatch, RootState } from '../../store/types'

import { BuyerRevenuesActionTypes, Revenues } from './types'

export { BuyerRevenuesActionTypes }

export const getBuyerRevenues =
  ({ partnerId, buyerId }: { partnerId: string; buyerId: string }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.BUYERS_OVERVIEW))
    try {
      const response = await getBuyerRevenuesAPI({ partnerId, buyerId })
      const revenues = camelize(response?.data)
      await dispatch(setBuyerRevenues(revenues as Revenues))
    } catch (error: unknown) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      const globalState = getState()
      errorLogger({ globalState: globalState as never })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.BUYERS_OVERVIEW))
    }
  }

export const setBuyerRevenues = (buyerRevenues: Revenues) => ({
  type: BuyerRevenuesActionTypes.SET_BUYER_REVENUES,
  payload: buyerRevenues,
})
